import React from 'react'
import PropTypes from 'prop-types'
import actionAddIcon from 'resources/actions_box_add_icon.png'
import HoverableItem from './common/HoverableItem'

export const CustomerPlaceholder = (props) => (
  <div style={ styles.placeholder(props.height) } />
)
CustomerPlaceholder.propTypes = {
  height: PropTypes.number
}

export const CustomerLabel = (props) => (
  <div style={{ ...styles.label, ...styles.color(props.color) }}>
    { props.label }
  </div>
)
CustomerLabel.propTypes = {
  color: PropTypes.string,
  label: PropTypes.string
}

export const AddActionButton = (props) => (
  <HoverableItem
    id={props.id}
    style={{ ...styles.hoverContainer, ...styles.hoverAction }}
    onPress={props.onPress}>
    <div style={styles.buttonRow}>
      <img src={actionAddIcon} width={16} height={16} />
      <div style={styles.buttonLabel}> { props.label } </div>
    </div>
  </HoverableItem>
)
AddActionButton.propTypes = {
  id: PropTypes.string,
  onPress: PropTypes.func.isRequired,
  label: PropTypes.string
}

export const ContactListItem = (props) => {
  const { id, contactItem, onContactSelected } = props
  return (
    <HoverableItem
      id={id}
      style={styles.hoverContainer}
      item={contactItem}
      onPress={onContactSelected}>
      <div style={styles.contactColumn}>
        <div style={styles.contactRow}>
          <div style={styles.contactLabel}>{ contactItem.contactName }</div>
        </div>
        <div style={styles.contactRow}>
          <div style={styles.emailLabel}>{ contactItem.email }</div>
          <div style={styles.phoneNumberLabel}>{ contactItem.phoneNumber }</div>
        </div>
        <div style={styles.contactRow}>
          <div style={styles.addressLabel}>{ contactItem.address }</div>
        </div>
      </div>
    </HoverableItem>
  )
}
ContactListItem.propTypes = {
  id: PropTypes.string.isRequired,
  contactItem: PropTypes.shape(),
  onContactSelected: PropTypes.func.isRequired
}

export const CustomerListItem = (props) => {
  const { id, customerItem, onCustomerSelected } = props
  return (
    <HoverableItem
      id={id}
      style={styles.hoverContainer}
      item={customerItem}
      onPress={onCustomerSelected}>
      <div style={styles.customer}>
        <div style={styles.customerLabel}>{ customerItem.name }</div>
      </div>
    </HoverableItem>
  )
}
CustomerListItem.propTypes = {
  id: PropTypes.string.isRequired,
  customerItem: PropTypes.shape(),
  onCustomerSelected: PropTypes.func.isRequired
}

const styles = {
  placeholder: (height) => ({ height: height }),
  label: { fontSize: 14, paddingBottom: 4 },
  color: (color) => ({ color: color }),
  hoverContainer: {padding: 10 },

  //For action button
  buttonRow: { display: 'flex', flexDirection: 'row'},
  buttonLabel: { marginLeft: 8 },
  hoverAction: { borderTopStyle: 'solid', borderTopWidth: 1, borderTopColor: '#e2e2e2' },

  //For ContactListItem
  contactColumn: { display: 'flex', flexDirection: 'column'},
  contactRow: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between' },
  contactLabel: { color: '#494949', fontSize: 14 },
  addressLabel: { fontSize: 12 },
  emailLabel: { fontSize: 12 },
  phoneNumberLabel: { fontSize: 12 },

  //For CustomerListItem
  customer: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between' },
  customerLabel: { color: '#494949', fontSize: 14 }
}



// WEBPACK FOOTER //
// ./src/customer/CustomerAccessories.js